import React from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useDocumentMeta from '../../utils/useDocumentMeta';
import PublicNavbar from '../../components/PublicNavbar/PublicNavbar';
import './CheckEmailPage.css';

const CheckEmailPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email || '';

    useDocumentMeta('seo-check-email-title', 'seo-check-email-desc', { canonicalPath: '/check-email' });

    return (
        <>
        <PublicNavbar />
        <div className="cep">
            <main className="cep-main">
                <div className="cep-card">
                    <div className="cep-badge">{t('cep-badge')}</div>
                    <h1 className="cep-title">{t('cep-title')}</h1>
                    <p className="cep-subtitle">
                        {email ? t('cep-subtitle-with-email', { email }) : t('cep-subtitle')}
                    </p>

                    <div className="cep-steps">
                        <div className="cep-step">
                            <span className="cep-step-number">1</span>
                            <div>
                                <p className="cep-step-title">{t('cep-step-1-title')}</p>
                                <p className="cep-step-body">{t('cep-step-1-body')}</p>
                            </div>
                        </div>
                        <div className="cep-step">
                            <span className="cep-step-number">2</span>
                            <div>
                                <p className="cep-step-title">{t('cep-step-2-title')}</p>
                                <p className="cep-step-body">{t('cep-step-2-body')}</p>
                            </div>
                        </div>
                        <div className="cep-step">
                            <span className="cep-step-number">3</span>
                            <div>
                                <p className="cep-step-title">{t('cep-step-3-title')}</p>
                                <p className="cep-step-body">{t('cep-step-3-body')}</p>
                            </div>
                        </div>
                    </div>

                    <div className="cep-actions">
                        <p className="cep-login-text">
                            {t('cep-login-prefix')}{' '}
                            <Link to="/login">{t('cep-login-link')}</Link>
                        </p>
                    </div>
                </div>
            </main>
        </div>
        </>
    );
};

export default CheckEmailPage;
